import { render, staticRenderFns } from "./ControleMotivos.vue?vue&type=template&id=7416a687&"
import script from "./ControleMotivos.vue?vue&type=script&lang=js&"
export * from "./ControleMotivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports